import { Component } from '@angular/core';

/**
 * Represents the EntryComponent class.
 */
@Component({
  selector: 'app-entry',
  templateUrl: './entry.component.html',
  styleUrls: ['./entry.component.scss'],
})
export class EntryComponent {}
